export var Environment;
(function (Environment) {
    Environment[Environment["pcWallet"] = 0] = "pcWallet";
    Environment[Environment["lightWallet"] = 1] = "lightWallet";
    Environment[Environment["androidBiWallet"] = 2] = "androidBiWallet";
    Environment[Environment["iosBiWallet"] = 3] = "iosBiWallet";
    Environment[Environment["other"] = 4] = "other";
})(Environment || (Environment = {}));
var myWindow = window;
export function getDappEnvironment() {
    if (myWindow.chain33Wallet) {
        return Environment.pcWallet;
    }
    if (myWindow.btyExtensionProvider) {
        return Environment.lightWallet;
    }
    var ua = myWindow.navigator.userAgent || myWindow.navigator.vendor || myWindow.opera;
    ua = ua.toLowerCase();
    var device = '';
    if (/android/.test(ua)) {
        device = 'ANDROID';
    }
    else if (/(iphone|ipad|ipod|ios)/.test(ua)) {
        device = 'IOS';
    }
    var appType = {};
    if (/wallet/.test(ua)) {
        appType.isWallet = true;
        var array = ua.split(";");
        var num = String(array.length - 1);
        appType.version = array[num];
    }
    if (appType.isWallet) {
        if (device === 'ANDROID') {
            return Environment.androidBiWallet;
        }
        if (device === 'IOS') {
            return Environment.iosBiWallet;
        }
    }
    return Environment.other;
}
var isFirstTime = true;
export function getDappEnvironmentDelay() {
    return new Promise(function (resolve) {
        // make suer extension inject script has run
        if (isFirstTime) {
            setTimeout(function () {
                resolve(getDappEnvironment());
                isFirstTime = false;
            }, 500);
        }
        else {
            resolve(getDappEnvironment());
        }
    });
}
//# sourceMappingURL=dappEnvironment.js.map